import { NoNav } from '@/layouts'

export default [
  { 
    path: '/alerts',
    component: NoNav,
    children: [
      {
        name: 'alerts/accept',
        path: 'accept',
        component: () => import('@/views/Alerts/Accept'),
      },
      {
        name: 'alerts/payment_method',
        path: 'payment_method',
        component:  () => import('@/views/Alerts/PaymentMethod'),
      },
      {
        name: 'alerts/needs_setup',
        path: 'activate',
        component: () => import('@/views/Wizard/StepA'),
      },
    ],
  },
]